import axios from 'axios'

export default {
    async startRegistration() {
        try{            
            const response = await axios.get(`WebAuthn/register/start`)                                                           
            return response
        }catch (error){
            console.log('WebAuthn startRegistration error: ', error)
            throw error
        }
    },
    async finishRegistration(data) {
        try{            
            //.post(url, responsePayload) -> Sends the flat object
            const response = await axios.post(`WebAuthn/register/finish`, data)            
            return response
        }catch (error){
            console.log('WebAuthn finishRegistration error: ', error)
            throw error
        }
    },
    async startAssertion(data) {
         try{            
            const response = await axios.post(`WebAuthn/assertion/start`, data)                                                           
            return response
        }catch (error){
            console.log('WebAuthn startAssertion error: ', error)
            throw error
        }
    },
    async finishAssertion(userId, sourceAppType, data) {
        try{            
            //.post(url, responsePayload) -> Sends the flat object
            const response = await axios.post(`WebAuthn/assertion/finish/${userId}/${sourceAppType}`, data)
            return response
        }catch (error){
            console.log('WebAuthn finishAssertion error: ', error)
            throw error
        }
    },
}